<script setup>
import {Head} from "@inertiajs/vue3";
import {onMounted, ref} from "vue";

let mediaQuery;
onMounted(() => {
    mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    mediaQuery.addEventListener('change', themeChange);
    themeChange()
});
const href = ref('/favicon.png');

function themeChange() {
    if (mediaQuery.matches) {
        href.value = '/favicon-dark.png';
    } else {
        href.value = '/favicon.png'
    }
}

</script>

<template>
    <Head>
        <link rel="icon" :href="href" type="image/png">
    </Head>
</template>
